import { oneOfType, node, arrayOf, string, object, bool } from 'prop-types'

const Span = ({ children, cssClass = '', text = '', otherProps = {}, role = '', ariaLabel, ariaHidden }) => {
  return (
    <span className={cssClass} role={role} aria-label={ariaLabel} {...otherProps} aria-hidden={ariaHidden}>
      {text || children}
    </span>
  )
}

Span.propTypes = {
  ariaHidden: bool,
  children: oneOfType([node, arrayOf(node)]),
  cssClass: string,
  otherProps: object,
  role: string,
  ariaLabel: string,
  text: string
}

export default Span
